/* WOOD NEWS (sxf.art/pages/wood-news).
   Reads sxf-woodnews-data.json (built weekly by alert-digest/site.py from hand-picked stories)
   and draws it. Every story is a link out to the original article; pictures are the articles'
   own share images, loaded by URL as link previews. */
(function () {
  var app = document.getElementById('woodnews-app');
  if (!app) return;
  var body = document.getElementById('wn-body');
  var chips = document.getElementById('wn-topics');
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var LINES = { trade: 1 };   // topics shown as one-liners, no pictures
  var data = null, current = 'all', mixedWeeks = false;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function day(iso) {           // "2026-10-09" -> "Oct 9"
    var p = (iso || '').split('-');
    return p.length === 3 ? MONTHS[+p[1] - 1] + ' ' + (+p[2]) : '';
  }
  // A small crop through wsrv.nl, a free image resizer. If that fails the original is tried once,
  // and if that fails too the story simply goes without a picture.
  function thumb(src, w, h) {
    return 'https://wsrv.nl/?url=' + encodeURIComponent(src) + '&w=' + w + '&h=' + h +
      '&fit=cover&a=attention&output=jpg&q=72';
  }
  function picture(s, lead) {
    var wrap = el('span', 'wn-pic');
    var img = new Image();
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.referrerPolicy = 'no-referrer';
    img.onerror = function () {
      if (!img.dataset.retry) { img.dataset.retry = '1'; img.src = s.image; return; }
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    };
    if (s.direct) { img.dataset.retry = '1'; img.src = s.image; }   // site.py found the resizer can't fetch this one
    else img.src = lead ? thumb(s.image, 1120, 630) : thumb(s.image, 414, 276);
    wrap.appendChild(img);
    // only worth saying when the page mixes this week with older ones
    if (mixedWeeks && s.week === data.updated) wrap.appendChild(el('span', 'wn-new', 'New'));
    return wrap;
  }
  function meta(s) {
    return [s.outlet, day(s.date)].filter(Boolean).join(' · ');
  }
  function words(s) {
    var t = el('span', 'wn-txt');
    var h = el('span', 'wn-head', s.headline);
    h.title = s.headline;   // long headlines are clamped by the stylesheet; the full one stays on hover
    t.appendChild(h);
    t.appendChild(el('span', 'wn-meta', meta(s)));
    // the outlet line already credits the outlet's own photo; anything else (a Commons photo,
    // another outlet's picture of the same story) is named
    if (s.image && s.credit && s.credit.toLowerCase().indexOf(s.outlet.toLowerCase()) < 0 &&
        s.outlet.toLowerCase().indexOf(s.credit.toLowerCase()) < 0) {
      t.appendChild(el('span', 'wn-credit', 'Photo: ' + s.credit));
    }
    return t;
  }
  function story(s, cls, lead) {
    var a = el('a', cls);
    a.href = s.url; a.target = '_blank'; a.rel = 'noopener';
    if (s.image) a.appendChild(picture(s, lead));
    a.appendChild(words(s));
    return a;
  }
  // The wood market: lumber futures, timber funds, forest and paper companies. Numbers only.
  function change(pct) {
    var s = el('span', 'wn-chg');
    s.textContent = (pct > 0 ? '▲ ' : pct < 0 ? '▼ ' : '– ') + Math.abs(pct).toFixed(1) + '%';
    return s;
  }
  function spark(line) {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg'), p = document.createElementNS(NS, 'polyline');
    svg.setAttribute('viewBox', '0 0 100 28');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('class', 'wn-spark');
    svg.setAttribute('aria-hidden', 'true');
    p.setAttribute('points', line.map(function (v, i) {
      return (i / (line.length - 1) * 100).toFixed(1) + ',' + (26 - v * 24).toFixed(1);
    }).join(' '));
    svg.appendChild(p);
    return svg;
  }
  function market(m) {
    var box = el('div', 'wn-mkt');
    var head = el('div', 'wn-mrow wn-mhead');
    ['', '1 year', 'Price', '1 week', '1 year'].forEach(function (t, i) {
      head.appendChild(el('span', i === 1 ? 'wn-mline' : i > 1 ? 'wn-num' : null, t));
    });
    box.appendChild(head);
    m.groups.forEach(function (g) {
      box.appendChild(el('div', 'wn-mgroup', g.label));
      g.rows.forEach(function (r) {
        var row = el('div', 'wn-mrow');
        var name = el('span', 'wn-mname', r.name);
        name.appendChild(el('i', null, r.symbol + (r.unit ? ' · ' + r.unit : '')));
        row.appendChild(name);
        var cell = el('span', 'wn-mline'); cell.appendChild(spark(r.line)); row.appendChild(cell);
        row.appendChild(el('span', 'wn-num wn-price', r.price));
        var w = change(r.week), y = change(r.year);
        w.className += ' wn-num'; y.className += ' wn-num';
        row.appendChild(w); row.appendChild(y);
        box.appendChild(row);
      });
    });
    box.appendChild(el('p', 'wn-mnote', 'Closing prices as of ' + day(m.asof) +
      ', updated weekly. Shown for information only, not investment advice. Source: Yahoo Finance.'));
    return box;
  }
  function section(topic, list) {
    var sec = el('section', 'wn-sec');
    sec.id = 'wn-' + topic.key;
    var head = el('div', 'wn-sechead');
    head.appendChild(el('h2', null, topic.label));
    if (topic.blurb) head.appendChild(el('p', null, topic.blurb));
    sec.appendChild(head);
    if (LINES[topic.key]) {
      if (data.market) sec.appendChild(market(data.market));
      if (!list.length) return sec;
      if (data.market) sec.appendChild(el('div', 'wn-sub', 'In the news'));
      var ul = el('ul', 'wn-lines');
      list.forEach(function (s) {
        var li = el('li', 'wn-line'), a = el('a', null, s.headline);
        a.href = s.url; a.target = '_blank'; a.rel = 'noopener';
        li.appendChild(a); li.appendChild(el('span', 'wn-meta', meta(s)));
        ul.appendChild(li);
      });
      sec.appendChild(ul);
      return sec;
    }
    // the first pick leads; the rest are listed beside it
    var row = el('div', 'wn-row');
    row.appendChild(story(list[0], 'wn-card' + (list.length === 1 ? ' wn-solo' : ''), true));
    if (list.length > 1) {
      var side = el('div', 'wn-side');
      list.slice(1).forEach(function (s) { side.appendChild(story(s, 'wn-item', false)); });
      row.appendChild(side);
    }
    sec.appendChild(row);
    return sec;
  }
  // THE ALMANAC: dated tree days, wild days and plant holidays from almanac.json. Dates that have
  // passed are dropped here, by the reader's own clock, so the list stays current between updates.
  var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'];
  function span(d) {               // "Oct 18–24", "Oct 31–Nov 2", "Jan 23"
    if (d.when) return d.when;
    if (!d.end || d.end === d.start) return day(d.start);
    var a = d.start.split('-'), b = d.end.split('-');
    return a[1] === b[1] ? day(d.start) + '–' + (+b[2]) : day(d.start) + '–' + day(d.end);
  }
  function almanac(al) {
    var now = new Date(), pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var today = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
    var later = (now.getFullYear() + 1) + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
    var days = al.days.filter(function (d) { return (d.end || d.start) >= today && d.start <= later; });
    var box = el('div', 'wn-alm');
    if (!days.length) { box.appendChild(el('p', 'wn-empty', 'Next year’s dates are on their way.')); return box; }
    var month = null, list = null;
    days.forEach(function (d, i) {
      var m = d.start.slice(0, 7);
      if (m !== month) {
        month = m;
        box.appendChild(el('h3', 'wn-almmonth', MONTH_NAMES[+m.slice(5) - 1] + ' ' + m.slice(0, 4)));
        list = el('ul', 'wn-almlist'); box.appendChild(list);
      }
      var li = el('li', 'wn-almday' + (i === 0 ? ' wn-almnext' : ''));
      li.appendChild(el('span', 'wn-almdate', span(d)));
      var txt = el('span', 'wn-almtxt');
      var top = el('span', 'wn-almtop');
      var name = d.link ? el('a', 'wn-almname', d.name) : el('span', 'wn-almname', d.name);
      if (d.link) { name.href = d.link; name.target = '_blank'; name.rel = 'noopener'; }
      top.appendChild(name);
      top.appendChild(el('span', 'wn-almkind wn-alm-' + d.kind, al.kinds[d.kind] || d.kind));
      if (d.start <= today) top.appendChild(el('span', 'wn-almnow', 'Today'));
      else if (i === 0) top.appendChild(el('span', 'wn-almnow', 'Next'));
      txt.appendChild(top);
      txt.appendChild(el('span', 'wn-almline', d.line));
      var where = [d.place, d.expected ? 'Expected dates' : ''].filter(Boolean).join(' · ');
      if (where) txt.appendChild(el('span', 'wn-meta', where));
      li.appendChild(txt);
      list.appendChild(li);
    });
    return box;
  }
  function draw() {
    body.textContent = '';
    data.topics.forEach(function (t) {
      if (current !== 'all' && current !== t.key) return;
      if (t.key === 'almanac') {
        if (!data.almanac) return;
        var asec = el('section', 'wn-sec'); asec.id = 'wn-almanac';
        var ahead = el('div', 'wn-sechead');
        ahead.appendChild(el('h2', null, t.label));
        if (t.blurb) ahead.appendChild(el('p', null, t.blurb));
        asec.appendChild(ahead); asec.appendChild(almanac(data.almanac)); body.appendChild(asec);
        return;
      }
      if (t.key === 'longview') {   // the stats section, drawn by sxf-longview.js
        if (!data.longview || !window.sxfLongview) return;
        var sec = el('section', 'wn-sec'); sec.id = 'wn-longview';
        var head = el('div', 'wn-sechead');
        head.appendChild(el('h2', null, t.label));
        if (t.blurb) head.appendChild(el('p', null, t.blurb));
        var root = el('div');
        sec.appendChild(head); sec.appendChild(root); body.appendChild(sec);
        window.sxfLongview(root, data.longview);
        return;
      }
      var list = data.stories.filter(function (s) { return s.topic === t.key; });
      if (list.length || (LINES[t.key] && data.market)) body.appendChild(section(t, list));
    });
    Array.prototype.forEach.call(chips.children, function (c) {
      var on = c.dataset.topic === current;
      c.classList.toggle('on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function chip(key, label, n) {
    var b = el('button', 'wn-chip', label);
    b.type = 'button'; b.dataset.topic = key;
    if (n != null) b.appendChild(el('i', null, String(n)));
    b.addEventListener('click', function () {
      current = key;
      try { history.replaceState(null, '', key === 'all' ? location.pathname + location.search : '#' + key); } catch (e) {}
      draw();
    });
    return b;
  }
  function start(d) {
    data = d;
    mixedWeeks = d.stories.some(function (s) { return s.week !== d.updated; });
    var want = (location.hash || '').slice(1);
    if (d.topics.some(function (t) { return t.key === want; })) current = want;
    chips.textContent = '';
    chips.appendChild(chip('all', 'All', d.stories.length));
    d.topics.forEach(function (t) {
      chips.appendChild(chip(t.key, t.label, t.key === 'longview' || t.key === 'almanac' ? null :
        d.stories.filter(function (s) { return s.topic === t.key; }).length));
    });
    var n = document.getElementById('wn-count'), u = document.getElementById('wn-updated');
    if (n) n.textContent = d.stories.length;
    if (u) u.textContent = day(d.updated);
    draw();
    window.addEventListener('hashchange', function () {   // sxf.art/pages/wood-news#beavers
      var k = (location.hash || '').slice(1) || 'all';
      if (k === 'all' || d.topics.some(function (t) { return t.key === k; })) { current = k; draw(); }
    });
  }

  fetch(app.dataset.src, { credentials: 'omit' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(start)
    .catch(function () {
      body.textContent = '';
      body.appendChild(el('p', 'wn-empty', 'The wood news could not be loaded. Try again in a minute.'));
    });
})();
